export default function Footer() {
  return (
    <>
      <style>{`
        /* Footer principal */
        .footer {
          background: #FF0000;
          color: white;
          font-family: 'Helvetica', Arial, sans-serif;
          width: 100%;
        }

        /* Sección superior con iconos */
        .footer-top {
          background: #D80000; /* Rojo más oscuro */
          padding: 40px 0;
        }

        .footer-features {
          max-width: 1200px;
          margin: 0 auto;
          padding: 0 40px;
          display: flex;
          justify-content: space-around;
          gap: 20px;
        }

        .feature-item {
          display: flex;
          flex-direction: column;
          align-items: center;
          text-align: center;
          flex: 1;
        }

        .feature-icon {
          margin-bottom: 12px;
        }

        .feature-text {
          color: white;
          font-size: 14px;
          font-weight: 500;
          line-height: 1.3;
          margin: 0;
          max-width: 180px;
        }

        /* Sección principal - 4 columnas lado a lado */
        .footer-main {
          padding: 60px 0;
          min-height: 300px;
        }

        .footer-content {
          max-width: 1200px;
          margin: 0 auto;
          padding: 0 40px;
          display: grid;
          grid-template-columns: 1fr 0.8fr 1fr 1.2fr; /* 25% 20% 25% 30% */
          gap: 40px;
          align-items: start;
        }

        .footer-column {
          color: white;
        }

        .footer-title {
          font-family: 'Helvetica', Arial, sans-serif;
          font-weight: bold;
          font-size: 16px;
          color: white;
          margin: 0 0 20px 0;
          text-transform: uppercase;
        }

        .footer-description {
          color: rgba(255, 255, 255, 0.8);
          font-size: 14px;
          line-height: 1.6;
          margin: 0;
        }

        .footer-links {
          list-style: none;
          padding: 0;
          margin: 0;
        }

        .footer-links li {
          margin-bottom: 12px;
        }

        .footer-links a {
          color: rgba(255, 255, 255, 0.8);
          text-decoration: none;
          font-size: 14px;
          line-height: 1.8;
          transition: color 0.3s ease;
        }

        .footer-links a:hover {
          color: white;
        }

        /* Newsletter */
        .newsletter-description {
          color: rgba(255, 255, 255, 0.8);
          font-size: 14px;
          margin: 0 0 20px 0;
          line-height: 1.6;
        }

        .newsletter-form {
          display: flex;
          gap: 10px;
          align-items: stretch;
        }

        .newsletter-input {
          flex: 1;
          padding: 12px 16px;
          border: none;
          border-radius: 4px;
          font-size: 14px;
          width: 200px;
          box-sizing: border-box;
        }

        .newsletter-button {
          padding: 12px 20px;
          background: white;
          color: black;
          border: none;
          border-radius: 4px;
          font-size: 14px;
          font-weight: bold;
          cursor: pointer;
          white-space: nowrap;
          transition: opacity 0.3s ease;
        }

        .newsletter-button:hover {
          opacity: 0.9;
        }

        /* Sección social y pago */
        .footer-bottom {
          padding: 40px 0;
          text-align: center;
        }

        .footer-bottom-container {
          max-width: 1200px;
          margin: 0 auto;
          padding: 0 40px;
        }

        .social-icons {
          display: flex;
          justify-content: center;
          gap: 15px;
          margin-bottom: 30px;
        }

        .social-link {
          display: flex;
          align-items: center;
          justify-content: center;
          transition: transform 0.3s ease;
        }

        .social-link:hover {
          transform: scale(1.1);
        }

        .social-icon {
          width: 24px;
          height: 24px;
        }

        /* Iconos de pago */
        .payment-icons {
          display: flex;
          justify-content: center;
          flex-wrap: wrap;
          gap: 8px;
          margin-bottom: 20px;
        }

        .payment-icon {
          width: 38px;
          height: 24px;
          background: white;
          border-radius: 4px;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 2px;
          box-sizing: border-box;
        }

        .payment-icon img {
          max-width: 100%;
          max-height: 100%;
          object-fit: contain;
        }

        /* Copyright */
        .copyright {
          color: rgba(255, 255, 255, 0.6);
          font-size: 12px;
          margin: 20px 0 0 0;
        }

        /* Barra marquee final */
        .footer-marquee {
          height: 60px;
          overflow: hidden;
          display: flex;
          align-items: center;
          border-top: 1px solid rgba(255, 255, 255, 0.2);
        }

        .marquee {
          display: flex;
          width: max-content;
          animation: marquee-scroll 40s linear infinite;
        }

        .marquee-content {
          display: flex;
          align-items: center;
          gap: 40px;
          flex-shrink: 0;
          min-width: 100vw;
          justify-content: center;
        }

        .marquee-text {
          color: white;
          font-family: 'Helvetica', Arial, sans-serif;
          font-weight: bold;
          font-size: 18px;
          white-space: nowrap;
        }

        .marquee-logo {
          height: 40px;
          width: auto;
          display: inline-block;
        }

        @keyframes marquee-scroll {
          from {
            transform: translateX(0%);
          }
          to {
            transform: translateX(-100%);
          }
        }

        /* Responsive */
        @media (max-width: 1024px) {
          .footer-content {
            grid-template-columns: 1fr;
            gap: 30px;
            text-align: center;
          }
          
          .footer-features {
            flex-direction: column;
            gap: 30px;
          }
          
          .newsletter-form {
            flex-direction: column;
            align-items: center;
          }
          
          .newsletter-input {
            width: 100%;
            max-width: 300px;
          }
        }

        @media (max-width: 768px) {
          .footer-features {
            padding: 0 20px;
          }
          
          .footer-content {
            padding: 0 20px;
          }
          
          .footer-bottom-container {
            padding: 0 20px;
          }
          
          .social-icons {
            gap: 12px;
          }
          
          .payment-icons {
            gap: 6px;
          }
          
          .marquee-text {
            font-size: 16px;
          }
          
          .marquee-logo {
            height: 30px;
          }
        }
      `}</style>
      
      <footer className="footer">
        {/* SECCIÓN SUPERIOR - ICONOS CON TEXTO */}
        <section className="footer-top">
          <div className="footer-features">
            <div className="feature-item">
              <div className="feature-icon">
                <svg aria-hidden="true" focusable="false" fill="none" strokeWidth="1" width="24" viewBox="0 0 24 24" stroke="white">
                  <path clipRule="evenodd" d="M15.75 23.238a3 3 0 0 0-3-3H9a3 3 0 0 0-3-3H.75v6h15 Z" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M6 20.238h3m2.25-3H21a.75.75 0 0 0 .75-.75v-6.75m-13.5 0v4.5" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
                  <path clipRule="evenodd" d="M6.75 6.738a.75.75 0 0 1 .75-.75h15a.75.75 0 0 1 .75.75v2.25a.75.75 0 0 1-.75.75h-15a.75.75 0 0 1-.75-.75v-2.25Z" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M15 17.238V5.988" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
                  <path clipRule="evenodd" d="M19.265 3.867a11.855 11.855 0 0 1-4.242 2.121 11.856 11.856 0 0 1 2.121-4.242C18.463.428 19.21.63 19.8 1.216c.59.586.784 1.333-.535 2.651Zm-8.531 0c1.257.985 2.7 1.707 4.242 2.121a11.838 11.838 0 0 0-2.121-4.242C11.537.428 10.79.63 10.2 1.216c-.59.586-.784 1.333.534 2.651Z" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              <p className="feature-text">Diseño gratis sin compromiso</p>
            </div>
            
            <div className="feature-item">
              <div className="feature-icon">
                <svg aria-hidden="true" focusable="false" fill="none" strokeWidth="1" width="24" viewBox="0 0 24 24" stroke="white">
                  <path clipRule="evenodd" d="M10.075 20.383a7.197 7.197 0 0 1-7.196-7.197c0-10.436 12.56-5.08 18.605-10.097a.445.445 0 0 1 .458-.046c.151.063.26.2.287.361 1.846 10.81-6.112 16.979-12.154 16.979Z" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M12.954 11.262a23.872 23.872 0 0 0-8.226 4.095L1 18.539" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              <p className="feature-text">Best fit & quality</p>
            </div>
            
            <div className="feature-item">
              <div className="feature-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M21 16V14L13 9V3.5C13 2.67 12.33 2 11.5 2S10 2.67 10 3.5V4L3 8V10L10 8.5V14L8 15.5V17L11.5 16L15 17V15.5L13 14V8.5L21 16Z" fill="white"/>
                </svg>
              </div>
              <p className="feature-text">Envíos gratis a toda Europa</p>
            </div>
            
            <div className="feature-item">
              <div className="feature-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M20 4H4C2.89 4 2.01 4.89 2.01 6L2 18C2 19.11 2.89 20 4 20H20C21.11 20 22 19.11 22 18V6C22 4.89 21.11 4 20 4ZM20 18H4V12H20V18ZM20 8H4V6H20V8Z" fill="white"/>
                  <circle cx="6" cy="15" r="1" fill="#FF0000"/>
                  <rect x="8" y="14.5" width="8" height="1" fill="#FF0000"/>
                </svg>
              </div>
              <p className="feature-text">Pagos individuales y Seguros</p>
            </div>
          </div>
        </section>

        {/* SECCIÓN PRINCIPAL - 4 COLUMNAS LADO A LADO */}
        <section className="footer-main">
          <div className="footer-content">
            {/* COLUMNA 1 - 25% */}
            <div className="footer-column">
              <p className="footer-description">
                UNITING CREWS WORLDWIDE THROUGH CUSTOM HOODIES WITH STREET-INSPIRED STYLE.
              </p>
            </div>

            {/* COLUMNA 2 - 20% */}
            <div className="footer-column">
              <h3 className="footer-title">ABOUT</h3>
              <ul className="footer-links">
                <li><a href="/customer-service">Atención al Cliente</a></li>
                <li><a href="/faqs">FAQS</a></li>
              </ul>
            </div>

            {/* COLUMNA 3 - 25% */}
            <div className="footer-column">
              <h3 className="footer-title">LEGAL</h3>
              <ul className="footer-links">
                <li><a href="/privacy-policy">Política de Privacidad</a></li>
                <li><a href="/terms-of-service">Términos de Servicio</a></li>
                <li><a href="/shipping-policy">Política de Envío</a></li>
                <li><a href="/return-policy">Política de Devolución</a></li>
                <li><a href="/cookies-policy">Política de Cookies</a></li>
                <li><a href="/legal-notice">Aviso Legal</a></li>
              </ul>
            </div>

            {/* COLUMNA 4 - 30% */}
            <div className="footer-column">
              <h3 className="footer-title">FTTY NEWS</h3>
              <p className="newsletter-description">
                Suscríbete para recibir ofertas exclusivas, nuevos diseños y novedades de FRAETERNITY.
              </p>
              <form className="newsletter-form">
                <input 
                  type="email" 
                  placeholder="Tu email" 
                  className="newsletter-input"
                  required
                />
                <button type="submit" className="newsletter-button">
                  Suscribirse
                </button>
              </form>
            </div>
          </div>
        </section>

        {/* SECCIÓN INFERIOR - REDES SOCIALES Y PAGO */}
        <section className="footer-bottom">
          <div className="footer-bottom-container">
            {/* ICONOS REDES SOCIALES - 24px */}
            <div className="social-icons">
              <a href="#" className="social-link" aria-label="Instagram">
                <svg className="social-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect x="2" y="2" width="20" height="20" rx="5" ry="5" fill="url(#instagram-gradient)"/>
                  <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37Z" fill="white"/>
                  <line x1="17.5" y1="6.5" x2="17.51" y2="6.5" stroke="white" strokeWidth="2" strokeLinecap="round"/>
                  <defs>
                    <linearGradient id="instagram-gradient" x1="0%" y1="0%" x2="100%" y2="100%">
                      <stop offset="0%" style={{stopColor: '#833ab4'}} />
                      <stop offset="50%" style={{stopColor: '#fd1d1d'}} />
                      <stop offset="100%" style={{stopColor: '#fcb045'}} />
                    </linearGradient>
                  </defs>
                </svg>
              </a>
              
              <a href="#" className="social-link" aria-label="TikTok">
                <svg className="social-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M19.321 5.562a5.124 5.124 0 0 1-.443-.258 6.228 6.228 0 0 1-1.137-.966c-.849-.936-1.37-2.226-1.37-3.338h-2.833v14.346c0 1.574-1.26 2.846-2.807 2.846-1.547 0-2.807-1.272-2.807-2.846 0-1.574 1.26-2.846 2.807-2.846.31 0 .608.051.884.146V9.887c-.292-.041-.586-.063-.884-.063-2.649 0-4.796 2.184-4.796 4.876 0 2.692 2.147 4.876 4.796 4.876 2.649 0 4.796-2.184 4.796-4.876V8.731a7.925 7.925 0 0 0 4.592 1.465V7.363c-1.533 0-2.944-.735-3.799-1.801z" fill="black"/>
                </svg>
              </a>
              
              <a href="#" className="social-link" aria-label="Twitter">
                <svg className="social-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M23 3a10.9 10.9 0 0 1-3.14 1.53 4.48 4.48 0 0 0-7.86 3v1A10.66 10.66 0 0 1 3 4s-4 9 5 13a11.64 11.64 0 0 1-7 2c9 5 20 0 20-11.5a4.5 4.5 0 0 0-.08-.83A7.72 7.72 0 0 0 23 3z" fill="#1DA1F2"/>
                </svg>
              </a>
              
              <a href="#" className="social-link" aria-label="Facebook">
                <svg className="social-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" fill="#1877F2"/>
                </svg>
              </a>
              
              <a href="#" className="social-link" aria-label="YouTube">
                <svg className="social-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" fill="#FF0000"/>
                </svg>
              </a>
            </div>

            {/* ICONOS DE PAGO - 38x24px */}
            <div className="payment-icons">
              <div className="payment-icon">
                <img src="https://cdn.shopify.com/s/files/1/0622/4658/4507/files/american_express.png?v=1738521050" alt="American Express" />
              </div>
              <div className="payment-icon">
                <img src="https://cdn.shopify.com/s/files/1/0622/4658/4507/files/apple_pay.png?v=1738521050" alt="Apple Pay" />
              </div>
              <div className="payment-icon">
                <img src="https://cdn.shopify.com/s/files/1/0622/4658/4507/files/google_pay.png?v=1738521050" alt="Google Pay" />
              </div>
              <div className="payment-icon">
                <img src="https://cdn.shopify.com/s/files/1/0622/4658/4507/files/maestro.png?v=1738521050" alt="Maestro" />
              </div>
              <div className="payment-icon">
                <img src="https://cdn.shopify.com/s/files/1/0622/4658/4507/files/mastercard.png?v=1738521050" alt="Mastercard" />
              </div>
              <div className="payment-icon">
                <img src="https://cdn.shopify.com/s/files/1/0622/4658/4507/files/paypal.png?v=1738521050" alt="PayPal" />
              </div>
              <div className="payment-icon">
                <img src="https://cdn.shopify.com/s/files/1/0622/4658/4507/files/shop_pay.png?v=1738521050" alt="Shop Pay" />
              </div>
              <div className="payment-icon">
                <img src="https://cdn.shopify.com/s/files/1/0622/4658/4507/files/union_pay.png?v=1738521050" alt="Union Pay" />
              </div>
              <div className="payment-icon">
                <img src="https://cdn.shopify.com/s/files/1/0622/4658/4507/files/visa.png?v=1738521050" alt="Visa" />
              </div>
            </div>

            {/* COPYRIGHT */}
            <p className="copyright">
              © 2024 FRAETERNITY. Todos los derechos reservados.
            </p>
          </div>
        </section>

        {/* BARRA MARQUEE FINAL */}
        <section className="footer-marquee">
          <div className="marquee">
            <div className="marquee-content">
              <span className="marquee-text">DESIGN IN SPAIN</span>
              <img 
                src="https://cdn.shopify.com/s/files/1/0622/4658/4507/files/Captura_de_pantalla_2025-02-04_a_las_18.20.00.png?v=1738693270&width=368" 
                alt="Design in Spain"
                className="marquee-logo"
              />
              <span className="marquee-text">FRAETERNITY ™</span>
              <img 
                src="https://cdn.shopify.com/s/files/1/0622/4658/4507/files/Captura_de_pantalla_2025-02-02_a_las_18.30.28.png?v=1738693541&width=920" 
                alt="Fraeternity"
                className="marquee-logo"
              />
              <span className="marquee-text">DESIGN IN SPAIN</span>
              <img 
                src="https://cdn.shopify.com/s/files/1/0622/4658/4507/files/Captura_de_pantalla_2025-02-04_a_las_18.20.00.png?v=1738693270&width=368" 
                alt="Design in Spain"
                className="marquee-logo"
              />
              <span className="marquee-text">FRAETERNITY ™</span>
              <img 
                src="https://cdn.shopify.com/s/files/1/0622/4658/4507/files/Captura_de_pantalla_2025-02-02_a_las_18.30.28.png?v=1738693541&width=920" 
                alt="Fraeternity"
                className="marquee-logo"
              />
            </div>
            <div className="marquee-content">
              <span className="marquee-text">DESIGN IN SPAIN</span>
              <img 
                src="https://cdn.shopify.com/s/files/1/0622/4658/4507/files/Captura_de_pantalla_2025-02-04_a_las_18.20.00.png?v=1738693270&width=368" 
                alt="Design in Spain"
                className="marquee-logo"
              />
              <span className="marquee-text">FRAETERNITY ™</span>
              <img 
                src="https://cdn.shopify.com/s/files/1/0622/4658/4507/files/Captura_de_pantalla_2025-02-02_a_las_18.30.28.png?v=1738693541&width=920" 
                alt="Fraeternity"
                className="marquee-logo"
              />
              <span className="marquee-text">DESIGN IN SPAIN</span>
              <img 
                src="https://cdn.shopify.com/s/files/1/0622/4658/4507/files/Captura_de_pantalla_2025-02-04_a_las_18.20.00.png?v=1738693270&width=368" 
                alt="Design in Spain"
                className="marquee-logo"
              />
              <span className="marquee-text">FRAETERNITY ™</span>
              <img 
                src="https://cdn.shopify.com/s/files/1/0622/4658/4507/files/Captura_de_pantalla_2025-02-02_a_las_18.30.28.png?v=1738693541&width=920" 
                alt="Fraeternity"
                className="marquee-logo"
              />
            </div>
          </div>
        </section>
      </footer>
    </>
  );
} 